import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import FavoritesMenuLayer, {
  FavoritesMenuLayerProps,
} from '../../../components/FavoritesMenuLayer';
import {
  favoriteMatchesMenu,
  favoriteTournamentMenuItems,
  isFavoritesLayerVisible,
} from '../../../selectors/prematch';

const mapStateToProps = (state: ReduxState): FavoritesMenuLayerProps => ({
  visible: isFavoritesLayerVisible(state),
  tournaments: favoriteTournamentMenuItems(state),
  matches: favoriteMatchesMenu(state),
  location: '/prematch/favorites',
});

export default connect(mapStateToProps)(FavoritesMenuLayer);
